<template>
  <div>
    <Headersys />
    <div class="content">
      <parser :key="new Date().getTime()" :form-conf="detailForm" />
      <el-timeline>
        <el-timeline-item v-for="(item, index) in tasks" :key="index" :icon="getTimelineItemIcon(item)"
          :type="getTimelineItemType(item)">
          <p style="font-weight: 700">任务：{{ item.name }}</p>
          <el-card :body-style="{ padding: '10px' }">
            <label v-if="item.assigneeUser" style="font-weight: normal; margin-right: 30px;">
              审批人：{{ item.assigneeUser.nickname }}
              <el-tag type="info" size="mini">{{ item.assigneeUser.deptName }}</el-tag>
            </label>
            <label style="font-weight: normal" v-if="item.createTime">创建时间：</label>
            <label style="color:#8a909c; font-weight: normal">{{ parseTime(item.createTime) }}</label>
            <label v-if="item.endTime" style="margin-left: 30px;font-weight: normal">审批时间：</label>
            <label v-if="item.endTime" style="color:#8a909c;font-weight: normal"> {{ parseTime(item.endTime)
              }}</label>
            <label v-if="item.durationInMillis" style="margin-left: 30px;font-weight: normal">耗时：</label>
            <label v-if="item.durationInMillis" style="color:#8a909c;font-weight: normal"> {{
              getDateStar(item.durationInMillis) }} </label>
            <p v-if="item.reason">
              <el-tag :type="getTimelineItemType(item)">{{ item.reason }}</el-tag>
            </p>
          </el-card>
        </el-timeline-item>
      </el-timeline>
      <div style="width: 100%;height: 10vh;"></div>
    </div>
    <Back />
  </div>
</template>
<script>
import Parser from '@/components/parser/Parser'
import { decodeFields } from "@/utils/formGenerator";
import { getDate } from "@/utils/dateUtils";
export default {
  name: '',
  components: {
    Parser
  },
  data() {
    return {
      //
      waitTime: 180,
      watiTimer: null,
      name: '',
      cerno: '',
      avatar: '',
      flowId: "",
      formVariables: {},//表单对应key value
      detailForm: {
        fields: []
      },
      tasks: [],
    };
  },
  created() {
    var userInfo = this.$store.state.suerInfo
    this.name = userInfo.name
    this.cerno = userInfo.cerno
    this.avatar = userInfo.avatar
    this.flowId = this.$route.query.flowId
    this.init()
  },
  mounted() {
    //
    // this.timeDown()
  },
  destroyed() {
    // console.log('页面销毁');
    clearTimeout(this.watiTimer);
  },
  methods: {
    init() {
      this.$rqt.sxsb_master_getById({
        flowId: this.flowId
      }).then(res => {
        this.formVariables = res.data.formVariables
        this.getFormJson(res.data.processDefinitionId)
        this.sxsbMasterTask(res.data.processInstanceId)
      })
    },
    // 使用流程id获取表单信息
    getFormJson(id) {
      this.$rqt.sxsb_process_definition_detail({ id }).then(res => {
        // console.log('表单信息', res);
        var row = res.data
        this.detailForm = {
          ...JSON.parse(row.formConf),
          disabled: true, // 表单禁用
          formBtns: false, // 按钮隐藏
          fields: decodeFields(row.formFields)
        }
        var keys = Object.keys(this.formVariables);
        keys.forEach(item => {
          // console.log('新keyitem', item);
          // if (item.includes('myFile')) {
          if (this.hasChinese(item)) {
            // console.log('拼上');
            var setBojStyle = {
              "__config__": {
                "label": item,
                "tag": "el-upload",
                "tagIcon": "upload",
                "layout": "colFormItem",
                "defaultValue": this.formVariables[item],
                "showLabel": true,
                "labelWidth": 250,
                "required": true,
                "span": 24,
                "showTip": false,
                "buttonText": "点击上传",
                "regList": [],
                "changeTag": true,
                "fileSize": 2,
                "sizeUnit": "MB",
                "document": "https://element.eleme.cn/#/zh-CN/component/upload",
                "formId": 123,
                "renderKey": "1231727602534988"
              },
              "__slot__": {
                "list-type": true
              },
              "action": "/infra/file/upload",
              "limit": 1,
              "disabled": true,
              "accept": "",
              "name": "file",
              "auto-upload": true,
              "list-type": "text",
              "multiple": true,
              "__vModel__": item
            }
            this.detailForm.fields.push(setBojStyle)
          } else {
            // console.log('不处理');
            var obj = this.detailForm.fields.filter(mod => {
              return mod.__vModel__ == item
            }).forEach(item => {
              item.__config__.defaultValue = this.formVariables[item.__vModel__]
            });
          }
        });
      })
    },
    // 检查字符串是否有汉字
    hasChinese(str) {
      for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i);
        if (charCode >= 0x4e00 && charCode <= 0x9fa5) {
          return true;
        }
      }
      return false;
    },
    // 获取审批记录
    sxsbMasterTask(id) {
      this.$rqt.sxsb_master_task(id).then(response => {
        console.log('审批记录', response);
        // 审批记录
        this.tasks = [];
        // 移除已取消的审批
        response.data.forEach(task => {
          if (task.result !== 4) {
            this.tasks.push(task);
          }
        });
        // 排序，将未完成的排在前面，已完成的排在后面；
        this.tasks.sort((a, b) => {
          // 有已完成的情况，按照完成时间倒序
          if (a.endTime && b.endTime) {
            return b.endTime - a.endTime;
          } else if (a.endTime) {
            return 1;
          } else if (b.endTime) {
            return -1;
            // 都是未完成，按照创建时间倒序
          } else {
            return b.createTime - a.createTime;
          }
        });
      })
    },
    getDateStar(ms) {
      return getDate(ms);
    },
    getTimelineItemIcon(item) {
      if (item.result === 1) {
        return 'el-icon-time';
      }
      if (item.result === 2) {
        return 'el-icon-check';
      }
      if (item.result === 3) {
        return 'el-icon-close';
      }
      if (item.result === 4) {
        return 'el-icon-remove-outline';
      }
      return '';
    },
    getTimelineItemType(item) {
      if (item.result === 1) {
        return 'primary';
      }
      if (item.result === 2) {
        return 'success';
      }
      if (item.result === 3) {
        return 'danger';
      }
      if (item.result === 4) {
        return 'info';
      }
      return '';
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--
        } else {
          this.waitTime = 180
          clearInterval(this.watiTimer)
          this.$router.replace('/')
        }
      }, 1000);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem - 40px);
  padding: 20px 5rem;
  background-color: #F1FAFC;
  // display: flex;
  // justify-content: space-between;
  // align-items: center;
  overflow-y: scroll;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>